import { lazy, useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';
import { useIntl } from 'react-intl';
import List from 'src/componentes/list/tree';
import ListColumn from 'src/componentes/list/list-column';
import Avatar from 'src/componentes/avatar';
import AvatarGroup from 'src/componentes/AvatarGroup';
import Info from 'src/componentes/info';
import formatDateFns from 'src/utils/formatDateFns';
import useAuth from 'src/hooks/useAuth';

const ComunicadoRiscoEdit = lazy(() => import('./edit'));

const ComunicadoEventoRiscoList = (props) => {
  const intl = useIntl();
  const { user, terms: resources } = useAuth();
  const { disabled, refreshAfterRemove, eventoRiscoId, model, refreshCount } =
    props;

  const [saved, setSaved] = useState(-1);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setSaved((prev) => prev + 1);
  }, [refreshAfterRemove]);

  const renderContentInfoStatus = () => (
    <div>
      {intl.formatMessage({
        id: 'hint.prontoEnvio',
      })}
    </div>
  );

  const renderDataEnvio = (i) => {
    if (!(i.dataEnvio && i.status?.id === 1)) return <div></div>;

    const { currentDisplay, currentLocale } = formatDateFns(user?.idioma, true);

    return (
      <div>
        {format(new Date(i.dataEnvio), currentDisplay, {
          locale: currentLocale,
        })}
      </div>
    );
  };

  const renderStatus = (i) =>
    i.status?.id === 1 ? (
      intl.formatMessage({ id: 'enviado' })
    ) : (
      <>
        {intl.formatMessage({ id: 'prontoEnvio' })}
        <Info
          id="prontoEnvio"
          placement="right"
          renderContent={renderContentInfoStatus}
        />
      </>
    );

  const renderResponsavel = (item) => (
    <Avatar
      size={37}
      showLabel
      showTooltip
      foto={item?.responsavel?.fotoArquivo}
      label={item?.responsavel?.nome}
    />
  );

  const renderDestinatarios = (item) => (
    <AvatarGroup max={5} avatarSize={37}>
      {item.destinatarios.length > 0 &&
        item.destinatarios.map((c) => (
          <Avatar
            key={`avatar-${c.id}-${item.id}`}
            showTooltip
            id={`avatar-${c.id}-${item.id}`}
            foto={c.fotoArquivo}
            label={c.nome}
          />
        ))}
    </AvatarGroup>
  );

  return (
    <List
      editComponent={ComunicadoRiscoEdit}
      url="/EventoRiscoComunicado"
      showDelete={true}
      showExportItem={false}
      showExport={false}
      valueField="descricao"
      saved={saved}
      showNew={!disabled}
      showMenu={!disabled}
      parameters={{ eventoRiscoId: eventoRiscoId }}
      afterSave={refreshCount}
      afterDelete={refreshCount}
      local
      modelValue={model.value}
      dataSource={model.value}
      {...props}
      resources={resources}
    >
      <ListColumn
        key="titulo"
        headerText={intl.formatMessage({ id: 'titulo' })}
        valueField="titulo"
        required
      />
      <ListColumn
        key="responsavel"
        headerText={intl.formatMessage({ id: 'label.responsavel' })}
        valueField="responsavel"
        valueFunction={renderResponsavel}
        required
      />
      <ListColumn
        key="destinatarios"
        headerText={intl.formatMessage({ id: 'label.destinatarios' })}
        valueField="destinatarios"
        valueFunction={renderDestinatarios}
        required
      />
      <ListColumn
        key="dataEnvio"
        headerText={intl.formatMessage({ id: 'dataEnvio' })}
        valueField="dataEnvio"
        valueFunction={renderDataEnvio}
      />
      <ListColumn
        key="status"
        headerText={intl.formatMessage({ id: 'status' })}
        valueField="titulo"
        valueFunction={renderStatus}
      />
    </List>
  );
};

export default ComunicadoEventoRiscoList;
